module["exports"] = ["سپرده", "برداشت از حساب", "پرداخت", "صورتحساب"];